import Dict from '@/utils/dict-utils'
import { purchaseTypeDict } from '@/dictionary/project/common'

/**
 * 订单状态
 */
export const purchaseOrderStatusDict = new Dict({
  EDITING: {
    value: 1,
    label: '编辑中',
    type: 'primary',
    permission: ['edit', 'delete']
  },
  PENDING: {
    value: 3,
    label: '审批中',
    type: 'warning',
    permission: ['detail']
  },
  PASS: {
    value: 4,
    label: '未收货',
    type: 'primary',
    permission: ['detail', 'receive', 'excel']
  },
  REJECT: {
    value: 5,
    label: '审核不通过',
    type: 'danger',
    permission: ['edit', 'delete', 'detail']
  },
  WITHDRAW: {
    value: 6,
    label: '审批撤回',
    type: 'info',
    permission: ['edit', 'delete']
  },
  COMPLETED: {
    value: 7,
    label: '已完成',
    type: 'success',
    permission: ['detail', 'excel']
  },
  WAIT_COMFIRM: {
    value: 8,
    label: '待确认',
    type: 'primary',
    permission: ['detail', 'excel']
  },
  COMFIRMED: {
    value: 9,
    label: '已确定',
    type: 'primary',
    permission: ['detail', 'excel']
  },
  REJECTED: {
    value: 10,
    label: '已拒绝',
    type: 'danger',
    permission: ['detail', 'excel']
  },
  PENDING_PAY: {
    value: 11,
    label: '待支付',
    type: 'primary',
    permission: ['detail', 'excel']
  },
  PAYING: {
    value: 12,
    label: '支付中',
    type: 'primary',
    permission: ['detail', 'excel']
  },
  PAY_SUCCESS: {
    value: 13,
    label: '支付成功',
    type: 'success',
    permission: ['detail', 'excel']
  },
})

/**
 * 订单推送状态
 */
export const purchaseOrderPushStatusDict = new Dict({
  PUSH_NOT: { value: 0, label: '未推送', type: 'info' },
  PUSHING: { value: 1, label: '已推送', type: 'primary' },
  PUSH_SUCCESS: { value: 2, label: '推送成功', type: 'success' },
  PUSH_FAIL: { value: 3, label: '推送失败', type: 'danger' }
})

/**
 * 是否推送sap
 */
export const purchaseOrderIsPushSapDict = new Dict({
  NO: { value: 0, label: '否' },
  YES: { value: 1, label: '是' }
})

/**
 * 订单来源
 * @property {1} PLAN 采购方案
 * @property {2} INQUIRY 询比单
 */
export const purchaseOrderSourceTypeDict = new Dict({
  PLAN: { value: 2, label: '定点采购', name: 'plan' },
  INQUIRY: { value: 3, label: '询比', name: 'inquiry' },
  DIRECT: { value: 4, label: '直接采购', name: 'direct' }
})

/**
 * 接单状态
 * @property {1} NOT_ORDERS 未接单
 * @property {2} ORDERS 已接单
 */
export const purchaseOrderReceivingStatusDict = new Dict({
  NOT_ORDERS: { value: 0, label: '未接单' },
  ORDERS: { value: 1, label: '已接单' }
})

/**
 * 供应商 确认价格状态
 */
export const purchaseOrderConfirmPriceStatusDict = new Dict({
  NO: { value: 0, label: '无需确认', purchaseLabel: '无需确认', type: 'primary' },
  PENDING: { value: 1, label: '待确认', purchaseLabel: '待确认', type: 'primary' },
  ACCEPTED: { value: 2, label: '同意', purchaseLabel: '已同意', type: 'success' },
  REJECTED: { value: 3, label: '拒绝', purchaseLabel: '已拒绝', type: 'danger' }
})

/**
 * 订单发货状态
 */
export const purchaseOrderShipStatusDict = new Dict({
  NOT_SHIP: { value: 1, label: '未送货', type: 'info', permission: ['detail', 'excel'] },
  SHIP: { value: 2, label: '部分送货', type: 'primary', permission: ['detail', 'excel'] },
  COMPLETED: { value: 3, label: '送货完成', type: 'success', permission: ['detail', 'excel'] },
  NOT_CONFIRM: { value: 4, label: '价格未确认', type: 'primary', permission: ['view'] },
  CONFIRMED: { value: 5, label: '已确认', type: 'success', permission: ['detail', 'excel'] },
  REJECTED: { value: 6, label: '已拒绝', type: 'danger', permission: ['detail'] },
  PENDING_PAY: { value: 7, label: '待支付', type: 'primary', permission: ['detail'] },
  PAYING: { value: 8, label: '支付中', type: 'primary', permission: ['detail'] }
})

/**
 * 服务费状态
 */
export const purchaseOrderServiceFeeStatusDict = new Dict({
  NO_PAY: { value: 0, label: '禁止缴纳', type: 'info' },
  PENDING_PAY: { value: 1, label: '待支付', type: 'primary' },
  PAYING: { value: 2, label: '支付中', type: 'primary' },
  PAY_SUCCESS: { value: 3, label: '支付成功', type: 'success' }
})

/**
 * 合同状态
 */
export const contractStatusDict = new Dict({
  INACTIVATED: { label: '未激活', value: 0, type: 'warning' },
  IN_PERFORMANCE: { label: '履约中', value: 1, type: 'primary' },
  ARCHIVE: { label: '合同归档', value: 2, type: 'success' },
  END: { label: '终止', value: 3, type: 'info' }
})

/**
 * 合同采购类型
 */
export const contractPurchaseTypeDict = new Dict({
  BIDDING: purchaseTypeDict.BIDDING,
  INQUIRY: purchaseTypeDict.INQUIRY,
  COMPETE: purchaseTypeDict.COMPETE,
  NEGOTIATION: Object.assign({}, purchaseTypeDict.NEGOTIATION_V2, {
    label: '谈判'
  })
})

/**
 * 合同关联谈判采购类型
 */
export const contractNegotiationTypeDict = new Dict({
  NEGOTIATION: { label: '谈判', value: 0 },
  NEGOTIATION_V2: { label: '分项谈判', value: 1 }
})
